import axios from 'axios';

// Create a custom axios instance with the base URL
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' 
    ? '/api' // In production, use relative path
    : 'http://localhost:2001/api', // In development, use the full server URL
});

// Add a request interceptor to add the token to each request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;
